import { useMemo } from 'react';
import { buildThemes, buildLightTheme, isLight } from '@theme/buildThemes';
import { addTypographyToTheme } from '@cvent/carina/components/Typography/addTypographyToTheme';
import { useThemeValues } from '@context/ThemeProvider';

const colorScheme = 'default';
const formula = 'rails';

/**
 * Builds the default theme for the event, based on primary, secondary and additionalColor2 colors.
 * Provides an addition `contrast` theme if additionalColor2 (used as custom background color) is dark
 * to be use with @components/context/ContrastThemeProvider.
 */
export const useEventThemes = () => {
  const { primary, secondary, background: additionalColor2 } = useThemeValues();

  const eventThemes = useMemo(() => {
    if (primary && secondary) {
      const { default: defaultTheme, dark: darkTheme } = buildThemes({ primary, secondary, additionalColor2 }, formula);

      // Assumes null `additionalColor2` is light theme
      const isLightBackground = additionalColor2 ? isLight(additionalColor2) : true;
      return [
        addTypographyToTheme(defaultTheme),
        isLightBackground ? null : addTypographyToTheme(darkTheme) // Only add typography if needed
      ];
    }

    // Use default light theme if no primary and secondary are provided
    const defaultTheme = addTypographyToTheme(buildLightTheme(null, colorScheme, formula));
    return [defaultTheme, null];
  }, [primary, secondary, additionalColor2]);

  return eventThemes;
};
